import React from "react";
import Profile from "./Profile";
import Navigation from "./Navigation";
import { Store, LayoutDashboard, FileText, ShoppingCart } from "lucide-react";
import SignOut from "./SignOut";
import memoLocks from "../../assets/logo_memolock.svg";
import { useWooCommerceOrders } from "../../services/API/GetWooCommerceOrdersAPI";
import { useDashBoardData } from "../../services/API/GetDashBoardDataAPI";

const LeftSidebar = ({ user, activeView, setActiveView }) => {
  const { data } = useWooCommerceOrders();

  const { data: dashboardData } = useDashBoardData(user);

  const orders = data?.data || [];
  const shops = dashboardData?.data?.shops ?? [];

  const latestShopDate = shops
    .map((shop) => new Date(shop.date_created).getTime())
    .filter((date) => !Number.isNaN(date))
    .sort((dateA, dateB) => dateB - dateA)[0];

  const lastSeenShopDate = Number(
    localStorage.getItem("lastSeenShopDate") || 0,
  );

  const hasNewShopAlert =
    Boolean(latestShopDate) && latestShopDate > lastSeenShopDate;

  const latestOrderId = orders
    .map((order) => Number(order.id))
    .filter(Boolean)
    .sort((a, b) => b - a)[0];

  const lastSeenOrderId = Number(
    localStorage.getItem("lastSeenWooOrderId") || 0,
  );

  const hasNewOrderAlert =
    Boolean(latestOrderId) && latestOrderId > lastSeenOrderId;

  const handleDashboardClick = () => {
    if (latestShopDate) {
      localStorage.setItem("lastSeenShopDate", String(latestShopDate));
    }

    setActiveView("Dashboard");
  };

  const handleEcommerceClick = () => {
    if (latestOrderId) {
      localStorage.setItem("lastSeenWooOrderId", String(latestOrderId));
    }

    setActiveView("Ecommerce");
  };

  return (
    <div className="relative h-full p-4">
      <img src={memoLocks} alt="Logo" className="mx-auto mb-6 h-16 w-auto" />

      <Profile />

      <div className="relative">
        <Navigation
          icon={LayoutDashboard}
          label="Dashboard"
          isActive={activeView === "Dashboard"}
          onClick={handleDashboardClick}
        />

        {hasNewShopAlert && (
          <span className="absolute left-40 top-1/2 -translate-y-1/2 rounded-full bg-red-500 px-2 py-0.5 text-xs font-bold text-white">
            New
          </span>
        )}
      </div>

      <Navigation
        icon={Store}
        label="Shops"
        isActive={activeView === "Shop"}
        onClick={() => setActiveView("Shop")}
      />

      <Navigation
        icon={FileText}
        label="Shop Logs"
        isActive={activeView === "ShopLogs"}
        onClick={() => setActiveView("ShopLogs")}
      />

      <div className="relative">
        <Navigation
          icon={ShoppingCart}
          label="E-commerce"
          isActive={activeView === "Ecommerce"}
          onClick={handleEcommerceClick}
        />

        {hasNewOrderAlert && (
          <span className="absolute left-35 top-1/2 -translate-y-1/2 rounded-full bg-red-500 px-2 py-0.5 text-xs font-bold text-white">
            New
          </span>
        )}
      </div>

      <div className="absolute bottom-4 left-4 right-4">
        <SignOut />
      </div>
    </div>
  );
};

export default LeftSidebar;
